<template>
  <PageHeader :class="$vuetify.display.width < 1280 ? 'mb-15' : ''"/>
  <LeftMenu v-if="$vuetify.display.width >= 1280"/>
  <v-row no-gutters>
    <v-col :cols="$vuetify.display.width < 1920 ? 12 : ''" class="main_col">
      <v-layout class="menu_on_mobile" v-if="$vuetify.display.width <= 1440">
        <v-main>
          <Main
              v-if="$route.name === names.MAIN"
          />
          <router-view v-else />
          <News v-if="$vuetify.display.width < 1920" class="news_on_mobile"/>
        </v-main>
      </v-layout>
      <v-main v-else>
        <Main
            v-if="$route.name === names.MAIN"
        />
        <router-view v-else />
        <News v-if="$vuetify.display.width < 1920" class="news_on_mobile"/>
      </v-main>
    </v-col>
    <v-col class="news_col" v-if="$vuetify.display.width >= 1920">
      <News/>
    </v-col>
  </v-row>
  <v-row no-gutters justify="center" style="margin-top: -20px" v-if="$vuetify.display.width < 1280">
    <v-img
        width="100%"
        max-height="200"
        aspect-ratio="1"
        :src="mobile_footer"
        alt="footer_logo"
    />
  </v-row>
</template>

<script>
import names from '@/modules/personal_account/routers/names'
import Main from "@/modules/personal_account/Main.vue"
import LeftMenu from "@/modules/personal_account/menus/LeftMenu.vue"
import PageHeader from "@/modules/personal_account/menus/PageHeader.vue"
import News from "@/modules/personal_account/news/News.vue"
import mobile_footer from "@/assets/img/mobile_footer.svg"

export default {
  name: 'UserBase',
  components: {
    News,
    PageHeader,
    LeftMenu,
    Main,
  },
  data () {
    return {
      mobile_footer: mobile_footer,
    }
  },
  computed: {
    names () {
      return names
    }
  },
}
</script>

<style scoped lang="scss">
.main_col {
  max-width: 81.75% !important;
}
.news_col {
  max-width: 18.25% !important;
  min-width: 350px;
}

.news_on_mobile {
  padding-left: 50px;
  padding-top: 0;
}

.menu_on_mobile {
  padding-left: 50px;
}

@media screen and (max-width: 1919px) {
  .main_col {
    max-width: 100% !important;
  }
}

@media screen and (max-width: 1279px) {
  .menu_on_mobile {
    padding-left: 0;
  }
}

@media screen and (max-width: 768px) {
  .news_on_mobile {
    padding-left: 20px;
  }
}

@media screen and (max-width: 369px) {
  .news_on_mobile {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
